import { FrontendEnvironmentSettings } from '@act/shared/environment';

let environment: FrontendEnvironmentSettings = null;
export const setEnvironment = (newEnvironment: FrontendEnvironmentSettings) => {
  environment = newEnvironment;
};

export const getEnvironment = () => {
  if (!environment) {
    throw new Error('Environment has not been set yet');
  }
  return environment;
};
